<template>
  <div v-if="value !== undefined">
    <v-card-title class="mx-n4">{{ i18n.t("_Summary") }}</v-card-title>
    <v-simple-table dense class="mb-8">
      <template v-slot:default>
        <thead>
        <tr
            v-for="(item, index) in items"
            :class="index % 2 === 0 ? 'background' : ''"
            :key="index"
        >
          <td>{{ item.name.toUpperCase() }}</td>

          <td v-if="isEditable || item.type === 'color'" class="pt-2">
            <v-text-field
                v-if="item.type === 'text-field'"
                dense
                :value="getProperty(value, item.key)"
                @input="
                  (newValue) => {
                    set(value, item.key, newValue);
                    $emit('input', value);
                  }
                "
                v-bind="item.props"
            >
            </v-text-field>
            <v-autocomplete
                v-if="item.type === 'autocomplete'"
                dense
                :value="getProperty(value, item.key)"
                @input="
                  (newValue) => {
                    set(value, item.key, newValue);
                    $emit('input', value);
                  }
                "
                v-bind="item.props"
            >
            </v-autocomplete>
            <v-select
                v-if="item.type === 'select'"
                dense
                :value="getProperty(value, item.key)"
                @input="
                  (newValue) => {
                    set(value, item.key, newValue);
                    $emit('input', value);
                  }
                "
                v-bind="item.props"
            >
            </v-select>
            <v-textarea
                v-if="item.type === 'textarea'"
                outlined
                :value="getProperty(value, item.key)"
                @input="
                  (newValue) => {
                    set(value, item.key, newValue);
                    $emit('input', value);
                  }
                "
                v-bind="item.props"
            >
            </v-textarea>
            <v-checkbox
                v-if="item.type === 'checkbox'"
                :input-value="getProperty(value, item.key)"
                @change="
                  (newValue) => {
                    set(value, item.key, newValue);
                    $emit('input', value);
                  }
                "
                v-bind="item.props"
            >
            </v-checkbox>
            <BaseColorPicker
                class="py-2"
                v-if="item.type === 'color'"
                :value="getProperty(value, item.key)"
                @input="
                  (newValue) => {
                    set(value, item.key, newValue);
                    $emit('input', value);
                  }
                "
                v-bind="item.props"
            >
            </BaseColorPicker>
            <BaseDatePicker
                v-if="item.type === 'date-picker'"
                :value="getProperty(value, item.key)"
                @change="
                  (newValue) => {
                    set(value, item.key, newValue);
                    $emit('input', value);
                  }
                "
                v-bind="item.props"
            >
            </BaseDatePicker>
          </td>
          <td v-else>
            <template v-if="item.type === 'autocomplete'">
              {{
                item.props.items.find(
                    (i) => i.value === getProperty(value, item.key)
                ).text
              }}
            </template>
            <template v-if="item.type === 'link'">
              <a v-if="!item.disabled" @click="navigateTo(item.link)">{{ getProperty(value, item.key) }}</a>
              <a v-else style="cursor: default; color: rgba(0, 0, 0, 0.87);">{{ getProperty(value, item.key) }}</a>
            </template>
            <template v-if="item.type !== 'autocomplete' && item.type !== 'link'">
              {{ getProperty(value, item.key) }}
            </template>
          </td>
        </tr>
        </thead>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import BaseColorPicker from "./BaseColorPicker.vue";
import BaseDatePicker from "./BaseDatePicker.vue";
import i18n from "../helper/i18n"

export default {
  components: {
    BaseColorPicker,
    BaseDatePicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      i18n: i18n
    }
  },
  methods: {
    getProperty(o, s) {
      s = s.replace(/\[(\w+)]/g, ".$1"); // convert indexes to properties
      s = s.replace(/^\./, ""); // strip a leading dot
      var a = s.split(".");
      for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
          o = o[k];
        } else {
          return;
        }
      }
      return o;
    },
    set(obj, path, value) {
      var schema = obj; // a moving reference to internal objects within obj
      var pList = path.split(".");
      var len = pList.length;
      for (var i = 0; i < len - 1; i++) {
        var elem = pList[i];
        if (!schema[elem]) schema[elem] = {};
        schema = schema[elem];
      }

      schema[pList[len - 1]] = value;
    },
    navigateTo(link) {
      window.location = link;
    }
  },
};
</script>

<style></style>
